import React, { useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { ColumnProps } from 'antd/lib/table';

import SalesOrderSelectDialog from '@totem/components/ticketing/details/dialogs/salesOrderKeys/SalesOrderSelectDialog';
import { Ticket } from '@totem/components/ticketing/ticketing';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { ForeignKey } from '@totem/types/common';
import { formatDate } from '@totem/utilities/common';

const SALES_ORDER_INSTANCES = [
  'NetSuite',
  'NETSUITE_SALES_ORDER_NUMBER',
  'NETSUITE_SALES_ORDER_KEY',
];

const INSTANCE_LABELS: Record<string, string> = {
  NetSuite: 'Sales Order Line',
  NETSUITE_SALES_ORDER_NUMBER: 'Sales Order Number',
  NETSUITE_SALES_ORDER_KEY: 'Sales Order Key',
};

type Props = {
  ticket: Ticket;
  keys: ForeignKey[];
  onKeysChanged: (keys: ForeignKey[]) => void;
};

const SalesOrderKeysTab = ({ ticket, keys, onKeysChanged }: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const salesOrderKeys = (keys ?? []).filter(
    (key) =>
      key.system === 'Contracts' &&
      SALES_ORDER_INSTANCES.includes(key.instance),
  );

  const columns: ColumnProps<ForeignKey>[] = [
    {
      title: 'Type',
      dataIndex: 'instance',
      key: 'instance',
      render: (instance: string) => INSTANCE_LABELS[instance] ?? instance,
    },
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Created By',
      dataIndex: 'createdByName',
      key: 'createdByName',
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (value: string) => formatDate(value),
    },
  ];

  return (
    <>
      <div style={{ marginBottom: 12 }}>
        <Button icon={<PlusOutlined />} onClick={() => setDialogOpen(true)}>
          Associate Sales Order
        </Button>
      </div>
      <IBTable
        size="small"
        columns={columns}
        dataSource={salesOrderKeys}
        rowKey={(record: ForeignKey) =>
          record.system + record.instance + record.key
        }
        pagination={{ showSizeChanger: true, defaultPageSize: 5 }}
      />
      {dialogOpen && (
        <SalesOrderSelectDialog
          ticket={ticket}
          keys={keys ?? []}
          onClose={() => setDialogOpen(false)}
          onSaved={(updatedKeys) => {
            onKeysChanged(updatedKeys);

            setDialogOpen(false);
          }}
        />
      )}
    </>
  );
};

export default SalesOrderKeysTab;
